import { Box, List, ListItem, Typography, Stack } from '@mui/material';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { savePreferences } from '../../SetUp/actions';
import { myPreferences, profilePhoto } from '../../../DataAccessLayer/services';
import { connect } from 'react-redux';
import { getData, putData } from '../../../DataAccessLayer';
import { getUser } from '../../Layout/utils';
import PortalAlert from '../../common/PortalAlert';
import PortalSwitch from '../../common/PortalSwitch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceSurprise } from '@fortawesome/pro-light-svg-icons';

class General extends Component {
  state = {
    // activeTab: 1
    isUserPhoto: false,
    isPhotoSynched: false,
  };

  toggleShowingPhoto = () => {
    this.setState({ isUserPhoto: !this.state.isUserPhoto }, () => {
      const preferences = {
        ...this.props.preferences,
        DisplayOptions: {
          ...this.props.preferences.DisplayOptions,
          Options: {
            ...this.props.preferences.DisplayOptions.Options,
            isUserPhoto: this.state.isUserPhoto,
          },
        },
      };

      putData(myPreferences, {
        preferences,
        midas: this.props.isImpersonating ? this.props.impersonation.midas : this.props.user.midas,
      })
        .then((_) => {
          this.props.savePreferences(preferences);
        })
        .catch((err) => console.log(err));
    });
  };

  //Θ(1) Sets active tab
  // onTabChange = (e, activeTab) => {
  //     this.setState({activeTab});
  // };

  componentDidMount() {
    this.setState({ isUserPhoto: this.props.isUserPhoto });
    this.checkPhotoSync();
  }

  checkPhotoSync = () => {
    getData(profilePhoto, true, true)
      .then((result) => {
        this.setState({ isPhotoSynched: Boolean(result) });
      })
      .catch(() => {
        this.setState({ isPhotoSynched: false });
      });
  };

  render() {
    const { isUserPhoto } = this.state;

    const user = getUser(this.props.user, this.props.impersonation);

    return (
      <Box className="wrapper general">
        <Typography component={'h3'} className="sr-only visibility-hidden">
          General Settings
        </Typography>

        <Stack direction="column" sx={{ mt: 2 }}>
          {!this.state.isPhotoSynched && (
            <Box
              id="settings_general_photoSyncAlert"
              severity="error"
              className="myOdu__alert error statusAlert p-2 mb-1"
            >
              <Stack direction="row" spacing={1} className="alert-body">
                <FontAwesomeIcon
                  id={this.props.id + '_icon_surpriseFace'}
                  icon={faFaceSurprise}
                  size="lg"
                />
                <Typography>
                  Your side navigation profile picture is currently unavailable or cannot be synced
                  from the University ID system. Your initials will appear in its place until the
                  photo becomes available. Once synced, the toggle below will allow switching
                  between the photo and initials.
                </Typography>
              </Stack>
            </Box>
          )}

          <Typography component="h3">Navigation Profile Photo</Typography>

          <Stack>
            <PortalSwitch
              id="settings_general_switch_togglePhoto"
              leftLabel="Show Photo"
              rightLabel="Show Initials"
              checked={!isUserPhoto}
              onChange={() => this.toggleShowingPhoto()}
              disabled={!this.state.isPhotoSynched}
              ariaLabel={
                this.state.isPhotoSynched
                  ? 'Toggle between photo and initials'
                  : 'Toggle unavailable since photo cannot be synced from University ID system'
              }
              tooltip={
                this.state.isPhotoSynched
                  ? 'Toggle between photo and initials'
                  : 'Toggle unavailable since photo cannot be synced from University ID system'
              }
              sx={{ mb: 2, mt: 1 }}
            />

            <Typography component={'p'} className="small">
              Your profile picture shown in the side navigation is synced from your University ID
              and is private to you. To change the photo used in the Portal, you must change the
              photo in the University ID system:
            </Typography>
            <ol>
              <li>
                {/* //TODO: add actual name and UIN to string */}
                Email the Card Center at{' '}
                <a
                  href={`mailto:cardCenter@odu.edu?subject=Update University ID Photo&body=Please update my University ID photo with the attached photograph.  Name - ${user.displayName} UIN - [UIN Here] Thank You.`}
                >
                  cardCenter@odu.edu
                </a>
                .
              </li>
              <li>Include your name and your University Identification Number (UIN).</li>
              <li>
                Attach a new photograph (headshot, solid-colored background, forward facing and no
                one else in the picture ).
              </li>
            </ol>

            <Typography component={'p'}>
              Once your photo is approved, it'll be updated in the University ID system and show up
              in the Portal and on your electronic University ID app. Charges apply only if you
              would like a new printed ID card.
            </Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  preferences: state.preferencesReducer.preferences,
  user: state.AWSReducer.user,
  isImpersonating: state.impersonationReducer.impersonation?.isImpersonating ?? false,
  impersonation: state.impersonationReducer.impersonation,
  isUserPhoto: state.preferencesReducer.preferences.DisplayOptions?.Options?.isUserPhoto ?? false,
});

const mapDispatchToProps = {
  savePreferences,
};

export default connect(mapStateToProps, mapDispatchToProps)(General);
